export const SHOPIFY_STOREFRONT_GRAPHQL_API = process.env.REACT_APP_SHOPIFY_STOREFRONT_GRAPHQL_API ?? "https://hyper-karting.myshopify.com/api/2025-01/graphql.json";
export const SHOPIFY_STOREFRONT_TOKEN = process.env.REACT_APP_SHOPIFY_STOREFRONT_TOKEN ?? "74c3480f0faab00d5878020b7767ede5";

// Active Kids vouchers are the first thing in this widget that talks to next-app; every
// other call goes to Shopify or a third party. Voucher validation cannot happen in the
// browser because Service NSW forbids their credentials leaving a back end.
export const HK_API_BASE_URL =
  process.env.REACT_APP_HK_API_BASE_URL ?? "https://app.hyperkarting.com.au/api";
